export default class GroupType {
    static Normal = 0;
    static Free = 1;
    static Restricted = 2;
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/model/groupType.js